var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.585786 0.585786C1.36683 -0.195262 2.63317 -0.195262 3.41421 0.585786L8 5.17157L12.5858 0.585786C13.3668 -0.195262 14.6332 -0.195262 15.4142 0.585786C16.1953 1.36683 16.1953 2.63317 15.4142 3.41421L10.8284 8L15.4142 12.5858C16.1953 13.3668 16.1953 14.6332 15.4142 15.4142C14.6332 16.1953 13.3668 16.1953 12.5858 15.4142L8 10.8284L3.41421 15.4142C2.63317 16.1953 1.36683 16.1953 0.585786 15.4142C-0.195262 14.6332 -0.195262 13.3668 0.585786 12.5858L5.17157 8L0.585786 3.41421C-0.195262 2.63317 -0.195262 1.36683 0.585786 0.585786Z",
    fill: "#737088"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCross);
export default __webpack_public_path__ + "static/media/grey-cross.4f48d1917dbb2d4af2370d50e12ac9be.svg";
export { ForwardRef as ReactComponent };